export const lerp = /*glsl*/ `
    float lerp(float target, float value, float alpha) {
        return value + ((target - value) * clamp(alpha, 0., 1.));
    }

    float damp(float target, float value, float alpha, float delta) {
        // TODO: uDelta!
        // float f = (uDelta * 0.51);
        return lerp(target, value, 1. - exp(log(1. - alpha)));

        // This looks like shit
        // return lerp(target, value, 1. - exp(log(1. - alpha) * (16.66 / delta)));
    }
`;

export const cubicIn = `
    float cubicIn(float t) {
        return t * t * t;
    }
`;

export const cubicOut = `
    float cubicOut(float t) {
        float f = t - 1.0;
        return f * f * f + 1.0;
    }
`;

export const roundBorders = /*glsl*/ `
    /*
    * HINT: pass inside value to get discardable value,
    * the return value is the border 
    */
    float roundedBorder(float thickness, float radius, vec2 uv, vec2 resolution, out float inside) {
        // Get square-pixel coordinates in range -1.0 .. 1.0
        float multiplier = max(resolution.x, resolution.y);
        vec2 ratio = resolution / multiplier;
        vec2 squareUv = (2.0 * uv - 1.0) * ratio; // -1.0 .. 1.0

        float squareThickness = (thickness / multiplier);
        float squareRadius = 2.0 * (radius / multiplier);
        vec2 size = ratio - vec2(squareRadius + squareThickness);


        vec2 q = abs(squareUv) - size;
        float d = min(max(q.x, q.y), 0.0) + length(max(q, 0.0)) - squareRadius;
        float dist = abs(d);
        float delta = fwidth(dist);
        float border = 1.0 - smoothstep(-delta, delta, dist - squareThickness);

        delta = fwidth(d);
        float limit = squareThickness * 0.5;
        inside = 1.0 - smoothstep(-delta, delta, d - limit);

        return border;
    }

    float roundedBorder(float thickness, float radius, vec2 uv, vec2 resolution) {
        float inside;
        return roundedBorder(thickness, radius, uv, resolution, inside);
    }
`;

export const transition = /*glsl*/ `
    // HINT: A margin of 0 gives issue on safari
    float falloffsmooth(float _input, float start, float end, float margin, float progress) {
        float p = mix(start - margin, end, progress);
        return smoothstep(p + margin, p, _input);
    }
`;

export const inverseMatrixTransform = /*glsl*/ `
    vec3 transform(vec3 p) {
        return (inverse(uTrackerWorldMatrix) * vec4(p, 1.0)).xyz;
    }
`;

export const spriteSheet = /*glsl*/ `
    vec2 getSpriteSheetUV(vec2 uv, vec2 size, vec2 pos) {
        return translateUV(scaleUV(uv, size, vec2(0.)), -vec2(pos.x / size.x, pos.y / size.y));
    }
`;

export const sdf = /*glsl*/ `
    float sdBox(vec3 p, vec3 b) {
        vec3 q = abs(p) - b;
        return length(max(q,0.0)) + min(max(q.x,max(q.y,q.z)),0.0);
    }

    float sdSphere(vec3 p, float s) {
        return length(p)-s;
    }
`;

export const signedDistanceFunctions = /*glsl*/ `
    float sdBox(vec3 p, vec3 b) {
        vec3 q = abs(p) - b;
        return length(max(q,0.0)) + min(max(q.x,max(q.y,q.z)),0.0);
    }

    float sdSphere(vec3 p, float s) {
        return length(p)-s;
    }
`;

// TODO: READ https://webglfundamentals.org/webgl/lessons/webgl-gpgpu.html
export const noise = /*glsl*/ `
    vec3 mod289(vec3 x) {
        return x - floor(x * (1.0 / 289.0)) * 289.0;
    }

    vec2 mod289(vec2 x) {
        return x - floor(x * (1.0 / 289.0)) * 289.0;
    }

    vec3 permute(vec3 x) {
        return mod289(((x*34.0)+1.0)*x);
    }

    vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
    vec4 permute(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}

    float getNoise(vec2 uv, float time) {
        float x = uv.x * uv.y * time * 1000.0;
        x = mod(x, 13.0) * mod(x, 123.0);
        float dx = mod(x, 0.01);
        float amount = clamp(0.1 + dx * 100.0, 0.0, 1.0);
        return amount;
    }

    float noise(vec2 v) {
        const vec4 C = vec4(
            0.211324865405187,  // (3.0-sqrt(3.0))/6.0
            0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)
            -0.577350269189626,  // -1.0 + 2.0 * C.x
            0.024390243902439
        ); // 1.0 / 41.0
        // First corner
        vec2 i  = floor(v + dot(v, C.yy) );
        vec2 x0 = v -   i + dot(i, C.xx);

        // Other corners
        vec2 i1;
        //i1.x = step( x0.y, x0.x ); // x0.x > x0.y ? 1.0 : 0.0
        //i1.y = 1.0 - i1.x;
        i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
        // x0 = x0 - 0.0 + 0.0 * C.xx ;
        // x1 = x0 - i1 + 1.0 * C.xx ;
        // x2 = x0 - 1.0 + 2.0 * C.xx ;
        vec4 x12 = x0.xyxy + C.xxzz;
        x12.xy -= i1;

        // Permutations
        i = mod289(i); // Avoid truncation effects in permutation
        vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
            + i.x + vec3(0.0, i1.x, 1.0 ));

        vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
        m = m*m ;
        m = m*m ;

        vec3 x = 2.0 * fract(p * C.www) - 1.0;
        vec3 h = abs(x) - 0.5;
        vec3 ox = floor(x + 0.5);
        vec3 a0 = x - ox;

        // Normalise gradients implicitly by scaling m
        // Approximation of: m *= inversesqrt( a0*a0 + h*h );
        m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );

        // Compute final noise value at P
        vec3 g;
        g.x  = a0.x  * x0.x  + h.x  * x0.y;
        g.yz = a0.yz * x12.xz + h.yz * x12.yw;
        return 130.0 * dot(m, g);
    }

    float noise3D(vec3 p){
        vec3 a = floor(p);
        vec3 d = p - a;
        d = d * d * (3.0 - 2.0 * d);

        vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
        vec4 k1 = permute(b.xyxy);
        vec4 k2 = permute(k1.xyxy + b.zzww);

        vec4 c = k2 + a.zzzz;
        vec4 k3 = permute(c);
        vec4 k4 = permute(c + 1.0);

        vec4 o1 = fract(k3 * (1.0 / 41.0));
        vec4 o2 = fract(k4 * (1.0 / 41.0));

        vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
        vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);

        return o4.y * d.y + o4.x * (1.0 - d.y);
    }
  

    float cnoise(vec3 v) {
        float t = v.z * 0.3;
        v.y *= 0.8;
        float noise = 0.0;
        float s = 0.5;
        noise += (sin(v.x * 0.9 / s + t * 10.0) + sin(v.x * 2.4 / s + t * 15.0) + sin(v.x * -3.5 / s + t * 4.0) + sin(v.x * -2.5 / s + t * 7.1)) * 0.3;
        noise += (sin(v.y * -0.3 / s + t * 18.0) + sin(v.y * 1.6 / s + t * 18.0) + sin(v.y * 2.6 / s + t * 8.0) + sin(v.y * -2.6 / s + t * 4.5)) * 0.3;
        return noise;
    }

    float fbm(vec2 x, float time) {
        float v = 0.0;
        float a = 0.5;
        vec2 shift = vec2(100);
        // Rotate to reduce axial bias
        mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
        for (int i = 0; i < 5; ++i) {
            v += a * noise(x * time);
            x = rot * x * 2.0 + shift;
            a *= 0.5;
        }
        return v;
    }


    // float fbm( vec2 p )
    // {
    //     float f = 0.0;
    //     float gat = 0.0;
        
    //     for (float octave = 0.; octave < 5.; ++octave)
    //     {
    //         float la = pow(2.0, octave);
    //         float ga = pow(0.5, octave + 1.);
    //         f += ga*noise( la * p ); 
    //         gat += ga;
    //     }
        
    //     f = f/gat;
        
    //     return f;
    // }


    // float fbm( vec2 p, float time) {
    //     float f = 0.0;
    //     float gat = 0.0;
        
    //     for (float octave = 0.; octave < 5.; ++octave)
    //     {
    //         float la = pow(2.0, octave);
    //         float ga = pow(0.5, octave + 1.);
    //         f += ga*noise( la * p ); 
    //         gat += ga;
    //     }
        
    //     f = f/gat;
        
    //     return f;
    // }

    // float fbm(vec3 p) {
    //     float f = 0.0;
    //     f += 0.5000 * cnoise(p); p = m * p * 2.02;
    //     f += 0.2500 * cnoise(p); p = m * p * 2.03;
    //     f += 0.12500 * cnoise(p); p = m * p * 2.01;
    //     f += 0.06250 * cnoise(p);
    //     return f;
    // }
`;

export const curlNoise = /*glsl*/ `
    vec3 curl(vec3 p) {
        float	eps	= 1., eps2 = 2. * eps;
        float	n1,	n2,	a,	b;

        float x = p.x;
        float y = p.y;
        float z = p.z;

        vec3 curl = vec3(0.);

        n1	=	noise(vec2( x,	y	+	eps ));
        n2	=	noise(vec2( x,	y	-	eps ));
        a	=	(n1	-	n2)/eps2;

        n1	=	noise(vec2( x,	z	+	eps));
        n2	=	noise(vec2( x,	z	-	eps));
        b	=	(n1	-	n2)/eps2;

        curl.x	=	a	-	b;

        n1 = noise(vec2( y,	z	+	eps));
        n2 = noise(vec2( y,	z	-	eps));
        a	=	(n1	-	n2)/eps2;

        n1	=	noise(vec2( x	+	eps,	z));
        n2	=	noise(vec2( x	+	eps,	z));
        b	=	(n1	-	n2)/eps2;

        curl.y	=	a	-	b;

        n1	=	noise(vec2( x	+	eps,	y));
        n2	=	noise(vec2( x	-	eps,	y));
        a	=	(n1	-	n2)/eps2;

        n1	=	noise(vec2(  y	+	eps,	z));
        n2	=	noise(vec2(  y	-	eps,	z));
        b	=	(n1	-	n2)/eps2;

        curl.z	=	a	-	b;

        return curl;
    }
`;

export const normalMap = /*glsl*/ `
    vec3 unpackNormal( vec3 eye_pos, vec3 surf_norm, sampler2D normal_map, float intensity, float scale, vec2 uv ) {
        surf_norm = normalize(surf_norm);
        
        vec3 q0 = dFdx( eye_pos.xyz );
        vec3 q1 = dFdy( eye_pos.xyz );
        vec2 st0 = dFdx( uv.st );
        vec2 st1 = dFdy( uv.st );
        
        vec3 S = normalize( q0 * st1.t - q1 * st0.t );
        vec3 T = normalize( -q0 * st1.s + q1 * st0.s );
        vec3 N = normalize( surf_norm );
        
        vec3 mapN = texture2D( normal_map, uv * scale ).xyz * 2.0 - 1.0;
        mapN.xy *= intensity;
        mat3 tsn = mat3( S, T, N );
        return normalize( tsn * mapN );
    }
`;

export const sampleAs3DTexture = /*glsl*/ `
    // Bilinear filtering by default
    // https://www.youtube.com/watch?v=rfQ8rKGTVlg#t=26m00s&ab_channel=GoogleDevelopers
    vec4 sampleAs3DTexture(sampler2D tex, vec3 texCoord, float size) {
        float sliceSize = 1.0 / size;                         // space of 1 slice
        float slicePixelSize = sliceSize / size;              // space of 1 pixel
        float sliceInnerSize = slicePixelSize * (size - 1.0); // space of size pixels
        float zSlice0 = min(floor(texCoord.z * size), size - 1.0);
        float zSlice1 = min(zSlice0 + 1.0, size - 1.0);
        float xOffset = slicePixelSize * 0.5 + texCoord.x * sliceInnerSize;
        float s0 = xOffset + (zSlice0 * sliceSize);
        float s1 = xOffset + (zSlice1 * sliceSize);
        vec4 slice0Color = texture2D(tex, vec2(s0, texCoord.y));
        vec4 slice1Color = texture2D(tex, vec2(s1, texCoord.y));
        float zOffset = mod(texCoord.z * size, 1.0);
        return mix(slice0Color, slice1Color, zOffset);
    }
`;

export const colorHelpers = /*glsl*/ `
    vec3 rgb2hsl(vec3 color) {
        vec3 hsl;

        float fmin = min(min(color.r, color.g), color.b);
        float fmax = max(max(color.r, color.g), color.b);
        float delta = fmax - fmin;

        hsl.z = (fmax + fmin) / 2.0;

        if (delta == 0.0) {
            hsl.x = 0.0;
            hsl.y = 0.0;
        }
        else {
            if (hsl.z < 0.5) hsl.y = delta / (fmax + fmin);
            else hsl.y = delta / (2.0 - fmax - fmin);

            float deltaR = (((fmax - color.r) / 6.0) + (delta / 2.0)) / delta;
            float deltaG = (((fmax - color.g) / 6.0) + (delta / 2.0)) / delta;
            float deltaB = (((fmax - color.b) / 6.0) + (delta / 2.0)) / delta;

            if (color.r == fmax )
                hsl.x = deltaB - deltaG;
            else if (color.g == fmax)
                hsl.x = (1.0 / 3.0) + deltaR - deltaB;
            else if (color.b == fmax)
                hsl.x = (2.0 / 3.0) + deltaG - deltaR;

            if (hsl.x < 0.0)
                hsl.x += 1.0;
            else if (hsl.x > 1.0)
                hsl.x -= 1.0;
        }

        return hsl;
    }

    vec3 hsl2rgb( vec3 c ) {
        vec3 rgb = clamp( abs(mod(c.x*6.0+vec3(0.0,4.0,2.0),6.0)-3.0)-1.0, 0.0, 1.0 );
        return c.z + c.y * (rgb-0.5)*(1.0-abs(2.0*c.z-1.0));
    }
`;

export const catMullRom = /*glsl*/ `
    vec3 catmullRomSpline(vec3 p0, vec3 p1, vec3 p2, vec3 p3, float t, vec2 c) {
        vec3 v0 = (p2 - p0) * c.x;
        vec3 v1 = (p3 - p1) * c.y;
        float t2 = t * t;
        float t3 = t * t * t;

        return vec3((2.0 * p1 - 2.0 * p2 + v0 + v1) * t3 + (-3.0 * p1 + 3.0 * p2 - 2.0 * v0 - v1) * t2 + v0 * t + p1);
    }
    vec3 catmullRomSpline(vec3 p0, vec3 p1, vec3 p2, vec3 p3, float t) {
        return catmullRomSpline(p0, p1, p2, p3, t, vec2(0.5, 0.5));
    }

    float catmullRomSpline(float p0, float p1, float p2, float p3, float t, vec2 c) {
        float v0 = (p2 - p0) * c.x;
        float v1 = (p3 - p1) * c.y;
        float t2 = t * t;
        float t3 = t * t * t;

        return float((2.0 * p1 - 2.0 * p2 + v0 + v1) * t3 + (-3.0 * p1 + 3.0 * p2 - 2.0 * v0 - v1) * t2 + v0 * t + p1);
    }
    float catmullRomSpline(float p0, float p1, float p2, float p3, float t) {
        return catmullRomSpline(p0, p1, p2, p3, t, vec2(1., 1.));
    }

    ivec4 getCatmullRomSplineIndices(float l, float p) {
        float index = floor(p);
        int i0 = int(max(0.0, index - 1.0));
        int i1 = int(index);
        int i2 = int(min(index + 1.0, l));
        int i3 = int(min(index + 2.0, l));

        return ivec4(i0, i1, i2, i3);
    }

    ivec4 getCatmullRomSplineIndicesClosed(float l, float p) {
        float index = floor(p);
        int i0 = int(index == 0.0 ? l : index - 1.0);
        int i1 = int(index);
        int i2 = int(mod(index + 1.0, l));
        int i3 = int(mod(index + 2.0, l));
    
        return ivec4(i0, i1, i2, i3);
    }
`;

// https://www.haroldserrano.com/blog/what-in-the-world-is-a-dual-quaternion
export const quaternion = /*glsl*/ `
    #define QUATERNION_IDENTITY vec4(0., 0., 0., 1.)
    
    vec4 quatFromAxisAngle(vec3 axis, float angle) {
        float halfAngle = angle * 0.5;
        return vec4(axis.xyz * sin(halfAngle), cos(halfAngle));
    }

    // DOC: https://stackoverflow.com/questions/12435671/quaternion-lookat-function
    vec4 lookAtQuat(vec3 source, vec3 dest, float angleMultiplier) {
        vec3 front = vec3(0., 0., 1.);
        vec3 up = vec3(0., 1., 0.);
        vec3 to = normalize(dest - source);

        vec3 axis = normalize(cross(front, to));
        if(length(axis) == 0.) {
            axis = up;
        }
        
        float d = dot(front, to);
        float ang = acos(d);

        return quatFromAxisAngle(axis, ang * angleMultiplier);
    }

    vec3 rotateVectorByQuaternion(vec4 q, vec3 v) {
        return v + 2.0 * cross(q.xyz, cross(q.xyz, v) + q.w * v);
    }

    vec4 qmul(vec4 q1, vec4 q2) {
        return vec4(
            q2.xyz * q1.w + q1.xyz * q2.w + cross(q1.xyz, q2.xyz),
            q1.w * q2.w - dot(q1.xyz, q2.xyz)
        );
    }

    // FIXME: expensive?
    vec4 slerp(vec4 a, vec4 b, float t) {
        // if either input is zero, return the other.
        if (length(a) == 0.0) {
            if (length(b) == 0.0) {
                return QUATERNION_IDENTITY;
            }
            return b;
        } else if (length(b) == 0.0) {
            return a;
        }

        float cosHalfAngle = a.w * b.w + dot(a.xyz, b.xyz);

        if (cosHalfAngle >= 1.0 || cosHalfAngle <= -1.0) {
            return a;
        } else if (cosHalfAngle < 0.0) {
            b.xyz = -b.xyz;
            b.w = -b.w;
            cosHalfAngle = -cosHalfAngle;
        }

        float blendA;
        float blendB;
        if (cosHalfAngle < 0.99) {
            // do proper slerp for big angles
            float halfAngle = acos(cosHalfAngle);
            float sinHalfAngle = sin(halfAngle);
            float oneOverSinHalfAngle = 1.0 / sinHalfAngle;
            blendA = sin(halfAngle * (1.0 - t)) * oneOverSinHalfAngle;
            blendB = sin(halfAngle * t) * oneOverSinHalfAngle;
        } else {
            // do lerp if angle is really small.
            blendA = 1.0 - t;
            blendB = t;
        }

        vec4 result = vec4(blendA * a.xyz + blendB * b.xyz, blendA * a.w + blendB * b.w);
        if (length(result) > 0.0) {
            return normalize(result);
        }

        return QUATERNION_IDENTITY;
    }
`;

export const rotation = /*glsl*/ `
    // Rotation matrix around the X axis.
    mat3 rotateX(float theta) {
        float c = cos(theta);
        float s = sin(theta);
        return mat3(
            vec3(1, 0, 0),
            vec3(0, c, -s),
            vec3(0, s, c)
        );
    }

    // Rotation matrix around the Y axis.
    mat3 rotateY(float theta) {
        float c = cos(theta);
        float s = sin(theta);
        return mat3(
            vec3(c, 0, s),
            vec3(0, 1, 0),
            vec3(-s, 0, c)
        );
    }

    // Rotation matrix around the Z axis.
    mat3 rotateZ(float theta) {
        float c = cos(theta);
        float s = sin(theta);
        return mat3(
            vec3(c, -s, 0),
            vec3(s, c, 0),
            vec3(0, 0, 1)
        );
    }

    // Identity matrix.
    mat3 identity() {
        return mat3(
            vec3(1, 0, 0),
            vec3(0, 1, 0),
            vec3(0, 0, 1)
        );
    }

    mat3 lookAt(vec3 dir, vec3 ref) {
        vec3 forward = normalize(dir);
    
        // if(dot(forward, vec3(0.0, 1.0, 0.0)) > 0.98) {
        //     ref = vec3(0.0, 0.0, 1.0);
        // }
    
        vec3 right = normalize(cross(ref, forward));
        vec3 up = normalize(cross(forward, right));
    
        return mat3(
            right.x, right.y, right.z,
            up.x, up.y, up.z,
            forward.x, forward.y, forward.z
        );
    }

    mat4 rotationMatrix(vec3 axis, float angle) {
        axis = normalize(axis);
        float s = sin(angle);
        float c = cos(angle);
        float oc = 1.0 - c;

        return mat4(oc * axis.x * axis.x + c,           oc * axis.x * axis.y - axis.z * s,  oc * axis.z * axis.x + axis.y * s,  0.0,
                    oc * axis.x * axis.y + axis.z * s,  oc * axis.y * axis.y + c,           oc * axis.y * axis.z - axis.x * s,  0.0,
                    oc * axis.z * axis.x - axis.y * s,  oc * axis.y * axis.z + axis.x * s,  oc * axis.z * axis.z + c,           0.0,
                    0.0,                                0.0,                                0.0,                                1.0);
    }
`;

export const vignette = `
    float vignette(vec2 uv, float boost, float reduction) {
        vec2 position = vUv - .5;
        return boost - length(position) * reduction;
    }
`;

export const saturate = `
    float saturate(float num) {
        return clamp(num, 0., 1.);
    }
`;

export const defaultVertex = /*glsl*/ `
    varying vec2 vUv;
    varying vec3 vEye;
    //varying vec3 vWorldPos;

    void main() {
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

        vUv = uv;
        vEye = cameraPosition;
    }
`;

export const defaultVertexRaw = /*glsl*/ `  
    precision highp float;

    attribute vec3 position;
    attribute vec2 uv;

    uniform mat4 modelViewMatrix;
    uniform mat4 projectionMatrix;

    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1. );
    }
`;

export const smallNoise = /* glsl */ `
    float hash(vec2 p) {
        p = 50.0 * fract(p * 0.3183099 + vec2(0.71, 0.113));
        return -1.0 + 2.0 * fract(p.x * p.y * (p.x + p.y));
    }

    float noise( vec2 p ) {
        vec2 i = floor( p );
        vec2 f = fract( p );

        vec2 u = f*f*(3.0-2.0*f);

        return mix( mix( hash( i + vec2(0.0,0.0) ), 
                        hash( i + vec2(1.0,0.0) ), u.x),
                    mix( hash( i + vec2(0.0,1.0) ), 
                        hash( i + vec2(1.0,1.0) ), u.x), u.y);
    }
`;

export const fresnel = /*glsl*/ `
    float getFresnel(vec3 normal, vec3 viewDir, float power) {
        float d = dot(normalize(normal), normalize(viewDir));
        return 1.0 - pow(abs(d), power);
    }

    // For refractive surfaces
    float getFresnel(float inIOR, float outIOR, vec3 normal, vec3 viewDir) {
        float ro = (inIOR - outIOR) / (inIOR + outIOR);
        float d = dot(normalize(normal), normalize(viewDir));
        return ro + (1. - ro) * pow((1. - d), 5.);
    }

    float getFresnelWithOffset( float amount, float offset, vec3 normal, vec3 view) {
        return offset + ( 1.0 - offset ) * pow( 1.0 - dot( normal , view ), amount );
    }
`;

export const range = /*glsl*/ `
    // TODO: Remove
    float range(float oldValue, float oldMin, float oldMax, float newMin, float newMax) {
    vec3 sub = vec3(oldValue, newMax, oldMax) - vec3(oldMin, newMin, oldMin);
    return sub.x * sub.y / sub.z + newMin;
}

vec2 range(vec2 oldValue, vec2 oldMin, vec2 oldMax, vec2 newMin, vec2 newMax) {
    vec2 oldRange = oldMax - oldMin;
    vec2 newRange = newMax - newMin;
    vec2 val = oldValue - oldMin;
    return val * newRange / oldRange + newMin;
}

vec3 range(vec3 oldValue, vec3 oldMin, vec3 oldMax, vec3 newMin, vec3 newMax) {
    vec3 oldRange = oldMax - oldMin;
    vec3 newRange = newMax - newMin;
    vec3 val = oldValue - oldMin;
    return val * newRange / oldRange + newMin;
}

float crange(float oldValue, float oldMin, float oldMax, float newMin, float newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

vec2 crange(vec2 oldValue, vec2 oldMin, vec2 oldMax, vec2 newMin, vec2 newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

vec3 crange(vec3 oldValue, vec3 oldMin, vec3 oldMax, vec3 newMin, vec3 newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

float map(float oldValue, float oldMin, float oldMax, float newMin, float newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

vec2 map(vec2 oldValue, vec2 oldMin, vec2 oldMax, vec2 newMin, vec2 newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

vec3 map(vec3 oldValue, vec3 oldMin, vec3 oldMax, vec3 newMin, vec3 newMax) {
    return clamp(range(oldValue, oldMin, oldMax, newMin, newMax), min(newMin, newMax), max(newMin, newMax));
}

float rangeTransition(float t, float x, float padding) {
    float transition = map(t, 0.0, 1.0, -padding, 1.0 + padding);
    return map(x, transition - padding, transition + padding, 1.0, 0.0);
}


`;

export const transformUV = /*glsl*/ `
    vec2 translateUV(vec2 uv, vec2 translate) {
        return uv - translate;
    }

    vec2 rotateUV(vec2 uv, float r, vec2 origin) {
        float c = cos(r);
        float s = sin(r);
        mat2 m = mat2(c, -s,
                    s, c);
        vec2 st = uv - origin;
        st = m * st;
        return st + origin;
    }

    vec2 scaleUV(vec2 uv, vec2 scale, vec2 origin) {
        vec2 st = uv - origin;
        st /= scale;
        return st + origin;
    }

    vec2 rotateUV(vec2 uv, float r) {
        return rotateUV(uv, r, vec2(0.5));
    }

    vec2 scaleUV(vec2 uv, vec2 scale) {
        return scaleUV(uv, scale, vec2(0.5));
    }

    vec2 skewUV(vec2 st, vec2 skew) {
        return st + st.gr * skew;
    }

    vec2 transformUV(vec2 uv, float a[9]) {

        // Array consists of the following
        // 0 translate.x
        // 1 translate.y
        // 2 skew.x
        // 3 skew.y
        // 4 rotate
        // 5 scale.x
        // 6 scale.y
        // 7 origin.x
        // 8 origin.y

        vec2 st = uv;

        //Translate
        st -= vec2(a[0], a[1]);

        //Skew
        st = st + st.gr * vec2(a[2], a[3]);

        //Rotate
        st = rotateUV(st, a[4], vec2(a[7], a[8]));

        //Scale
        st = scaleUV(st, vec2(a[5], a[6]), vec2(a[7], a[8]));

        return st;
    }
`;

export const noiseUV = /*glsl*/ `
    vec2 morphUV(vec2 uv) {
        float noiseScale = 1.;
        float noiseTime = 2.;
        float noiseStrength = 2.;

        float noise = cnoise((vWorldPos * noiseScale) + uTime * noiseTime);
        float scale = 1.0 + (noise * noiseStrength * 0.1);

        return scaleUV(uv, vec2(scale));
    }
`;

export const refract = /*glsl*/ `
    vec4 glassRefract(vec3 norm, vec2 offset, float darkness, float fresnelPow, float morph) {
        vec3 mvpos = normalize(-vViewDir);
        float fresnel = 0.5 + 0.5 * abs(dot(-mvpos, norm));
        
        vec2 scalar = mix(vec2(0.1), norm.xz, vec2(0.5));
        vec2 st = gl_FragCoord.xy / uResolution.xy;

        vec4 refractC = max(texture2D(uScene, st) * darkness, texture2D(uScene2, st) * 0.9);

        //st = gl_FragCoord.xy / uResolution.xy;

        st = mix(st, morphUV(st), morph);

        // Values that are too high cause banding
        st -= offset * scalar;

        vec4 reflectC = max(texture2D(uScene, st), texture2D(uScene2, st));

        vec4 scene = mix(reflectC, refractC, pow(fresnel, 5.));
        scene = mix(scene, vec4(0.0), step(length(scene.rgb), 0.01));
        return vec4(scene.rgb * fresnel, 1.);                
    }
`;

export const RGBShift = /*glsl*/ `
    vec4 RGBShift(sampler2D tex, vec2 uv, float angle, float amount) {
        vec2 offset = vec2(cos(angle), sin(angle)) * amount;

        vec4 r = texture2D(tex, uv + offset);
        vec4 g = texture2D(tex, uv);
        vec4 b = texture2D(tex, uv - offset);
        return vec4(r.r, g.g, b.b, g.a);
    }

    // vec4 chromaticShift(sampler2D tex, vec2 uv, vec3 view, vec3 normal, float ratio) {
    //     vec3 refractVec = refract(view, normal, ratio);

    //     vec4 r = texture2D(tex, uv + refractVec.xy);
    //     vec4 g = texture2D(tex, uv + refractVec.xy);
    //     vec4 b = texture2D(tex, uv + refractVec.xy);

    //     return vec4(r.r, g.g, b.b, g.a);
    // }
`;

export const aastep = /*glsl*/ `
    float aastep(float threshold, float value) {
        // float afwidth = length(vec2(dFdx(value), dFdy(value))) * 0.70710678118654757;
        float afwidth = fwidth(value) * 0.5;
        return smoothstep(threshold-afwidth, threshold+afwidth, value);
    }

    float aastep(float threshold, float value, float padding) {
        return smoothstep(threshold - padding, threshold + padding, value);
    }

    vec2 aastep(vec2 threshold, vec2 value) {
        return vec2(
            aastep(threshold.x, value.x),
            aastep(threshold.y, value.y)
        );
    }
`;

export const arc = /*glsl*/ `
    float draw_circle(vec2 coord, float radius) {
        return aastep(length(coord), radius, 0.01);
    }

    float draw_circle_outline(vec2 coord, float radius, float stroke) {
        float circle = draw_circle(coord, radius);
        float circle_stroke = draw_circle(coord, radius + stroke);
        return circle_stroke - circle;
    }

    float arc_segment(vec2 coord, float startAngle, float endAngle) {
        const float kInvPi = 1.0 / 3.14159265;
        float angle = atan(coord.x, coord.y) * kInvPi * 0.5;
        angle = fract(angle - startAngle);
        float segment = step(angle, endAngle);
        segment *= step(0.0, angle);
        return mix(segment, 1.0, step(1.0, endAngle));
    }

    float draw_arc_outline(vec2 coord, float radius, float stroke, float startAngle, float endAngle) {
        float circle_outline = draw_circle_outline(coord, radius, stroke);
        circle_outline *= arc_segment(coord, startAngle, endAngle);
        return circle_outline;
    }
`;

export const combinationSDF = /*glsl*/ `
    float opSmoothUnion( float d1, float d2, float k ) {
        float h = max(k-abs(d1-d2),0.0);
        return min(d1, d2) - h*h*0.25/k;
    }

    float opSmoothSubtraction( float d1, float d2, float k ) {
        return -opSmoothUnion(d1,-d2,k);
        
        //float h = max(k-abs(-d1-d2),0.0);
        //return max(-d1, d2) + h*h*0.25/k;
    }

    float opSmoothIntersection( float d1, float d2, float k ) {
        return -opSmoothUnion(-d1,-d2,k);

        //float h = max(k-abs(d1-d2),0.0);
        //return max(d1, d2) + h*h*0.25/k;
    }
`;

export const cheapAA = /*glsl*/ `
    float cheapAA(vec2 st, float initialAlpha, vec2 cut) {
        float alpha = initialAlpha;
        
        alpha *= aastep(cut.x, st.x);
        alpha *= 1. - aastep(1. - cut.x, st.x);
        alpha *= aastep(cut.y, st.y);
        alpha *= 1. - aastep(1. - cut.y, st.y);

        return alpha;
    }
`;

export const staggeredIndex = /*glsl*/ `
    float staggeredIndex(float index, float progress, float smoothness) {
        return smoothstep(0., -smoothness, index - (progress * (1. + smoothness)));
    }
`;

export const swirl = /*glsl*/ `
    
    float swirl(sampler2D tex, vec2 st, vec2 scale, vec2 speed, float smoothness, bool invertXY) {
        vec2 uv0 = st;
        vec2 uv1 = st;
        if(invertXY == true) {
            uv0 = (st * scale.x) + vec2(uTime * speed.x, 0.);
            uv1 = (st * scale.y) + vec2(0.0, -uTime * speed.y);
        } else {
            uv0 = (st * scale.x) + vec2(uTime * speed.x);
            uv1 = (st * scale.y) - vec2(-uTime * speed.y);
        }

        vec4 sw1 = texture2D(tex, uv0);
        vec4 sw2 = texture2D(tex, uv1);

        return opSmoothIntersection(sw1.r, sw2.r, smoothness);
    }
`;

// HINT: Res = container size!
// It's only resolution when the image is full screen
export const image = /*glsl*/ `
    vec2 resizeUVCover(vec2 uv, vec2 size, vec2 res) {
        vec2 ratio = vec2(
            min((res.x / res.y) / (size.x / size.y), 1.0),
            min((res.y / res.x) / (size.y / size.x), 1.0)
        );

        return vec2(
            uv.x * ratio.x + (1.0 - ratio.x) * 0.5,
            uv.y * ratio.y + (1.0 - ratio.y) * 0.5
        );
    }

    vec2 resizeUVContain(vec2 uv, vec2 size, vec2 res) {
        float tAspect = size.x / size.y;
        float pAspect = res.x / res.y;
        
        vec2 scale = vec2(1.0, 1.0);
        vec2 offset = vec2(0.0, 0.0);
        
        if (tAspect > pAspect) {
            scale.y = pAspect / tAspect;
            offset.y = (1.0 - scale.y) / 2.0;
        } else {
            scale.x = tAspect / pAspect;
            offset.x = (1.0 - scale.x) / 2.0;
        }
        
        return (uv - offset) / scale;
    }

    vec2 resizeUVAspect(vec2 uv, vec2 imageSize, vec2 containerSize, float zoom) {
        vec2 s = containerSize / min(containerSize.x, containerSize.y);
        vec2 i = imageSize / min(imageSize.x, imageSize.y);
        float rs = s.x / s.y;
        float ri = i.x / i.y;
        
        vec2 new = rs < ri ? vec2(i.x * s.y / i.y, s.y) : vec2(s.x, i.y * s.x / i.x);
        vec2 offset = (rs < ri ? vec2((new.x - s.x) / 2.0, 0.0) : vec2(0.0, (new.y - s.y) / 2.0)) / new;
        
        vec2 scaledUV = uv * s / new + offset;
        vec2 zoomedUV = (scaledUV - vec2(0.5)) / zoom + vec2(0.5);
        
        return zoomedUV;
    }
`;

export const matcap = /*glsl*/ `
    vec2 reflectMatcapSimple(vec3 eye, vec3 normal) {
        vec3 reflected = reflect(eye, normal);
        float m = 2.8284271247461903 * sqrt( reflected.z+1.0 );
        return reflected.xy / m + 0.5;
    }

    vec2 reflectMatcap(vec3 position, mat4 modelViewMatrix, mat3 normalMatrix, vec3 normal) {
        vec4 p = vec4(position, 1.0);
        
        vec3 e = normalize(vec3(modelViewMatrix * p));
        vec3 n = normalize(normalMatrix * normal);
        vec3 r = reflect(e, n);
        float m = 2.0 * sqrt(
            pow(r.x, 2.0) +
            pow(r.y, 2.0) +
            pow(r.z + 1.0, 2.0)
        );
        
        vec2 uv = r.xy / m + .5;
        
        return uv;
    }

    vec2 reflectMatcap(vec3 position, mat4 modelViewMatrix, vec3 normal) {
        vec4 p = vec4(position, 1.0);
        
        vec3 e = normalize(vec3(modelViewMatrix * p));
        vec3 n = normalize(normal);
        vec3 r = reflect(e, n);
        float m = 2.0 * sqrt(
                            pow(r.x, 2.0) +
                            pow(r.y, 2.0) +
                            pow(r.z + 1.0, 2.0)
                            );
        
        vec2 uv = r.xy / m + .5;
        
        return uv;
    }

    vec2 reflectMatcap(vec4 mvPos, vec3 normal) {
        vec3 e = normalize(vec3(mvPos));
        vec3 n = normalize(normal);
        vec3 r = reflect(e, n);
        float m = 2.0 * sqrt(
                            pow(r.x, 2.0) +
                            pow(r.y, 2.0) +
                            pow(r.z + 1.0, 2.0)
                            );

        vec2 uv = r.xy / m + .5;

        return uv;
    }
`;

export const mathDefines = /*glsl*/ `
#ifndef QTR_PI
#define QTR_PI 0.78539816339
#endif
#ifndef HALF_PI
#define HALF_PI 1.5707963267948966192313216916398
#endif
#ifndef PI
#define PI 3.1415926535897932384626433832795
#endif
#ifndef TWO_PI
#define TWO_PI 6.2831853071795864769252867665590
#endif
#ifndef TAU
#define TAU 6.2831853071795864769252867665590
#endif
#ifndef INV_PI
#define INV_PI 0.31830988618379067153776752674503
#endif
#ifndef INV_SQRT_TAU
#define INV_SQRT_TAU 0.39894228040143267793994605993439  // 1.0/SQRT_TAU
#endif
#ifndef SQRT_HALF_PI
#define SQRT_HALF_PI 1.25331413732
#endif
#ifndef PHI
#define PHI 1.618033988749894848204586834
#endif
#ifndef EPSILON
#define EPSILON 0.0000001
#endif
#ifndef GOLDEN_RATIO
#define GOLDEN_RATIO 1.6180339887
#endif
#ifndef GOLDEN_RATIO_CONJUGATE 
#define GOLDEN_RATIO_CONJUGATE 0.61803398875
#endif
#ifndef GOLDEN_ANGLE // (3.-sqrt(5.0))*PI radians
#define GOLDEN_ANGLE 2.39996323
#endif
`;

export const noiseBlur = /*glsl*/ `

${mathDefines}

#ifndef SAMPLER_FNC
#if __VERSION__ >= 300
#define SAMPLER_FNC(TEX, UV) texture(TEX, UV)
#else
#define SAMPLER_FNC(TEX, UV) texture2D(TEX, UV)
#endif
#endif

#ifndef SAMPLER_TYPE
#define SAMPLER_TYPE sampler2D
#endif


#ifndef NEAREST_FLOOR_FNC
#define NEAREST_FLOOR_FNC(UV) floor(UV)
#endif

#ifndef FNC_NEAREST
#define FNC_NEAREST
vec2 nearest(in vec2 v, in vec2 res) {
    vec2 offset = 0.5 / (res - 1.0);
    return NEAREST_FLOOR_FNC(v * res) / res + offset;
}
#endif

#ifndef RANDOM_SCALE
#ifdef RANDOM_HIGHER_RANGE
#define RANDOM_SCALE vec4(.1031, .1030, .0973, .1099)
#else
#define RANDOM_SCALE vec4(443.897, 441.423, .0973, .1099)
#endif
#endif

#ifndef FNC_RANDOM
#define FNC_RANDOM
float random(in float x) {
#ifdef RANDOM_SINLESS
    x = fract(x * RANDOM_SCALE.x);
    x *= x + 33.33;
    x *= x + x;
    return fract(x);
#else
    return fract(sin(x) * 43758.5453);
#endif
}

float random(in vec2 st) {
#ifdef RANDOM_SINLESS
    vec3 p3  = fract(vec3(st.xyx) * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
#else
    return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453);
#endif
}

float random(in vec3 pos) {
#ifdef RANDOM_SINLESS
    pos  = fract(pos * RANDOM_SCALE.xyz);
    pos += dot(pos, pos.zyx + 31.32);
    return fract((pos.x + pos.y) * pos.z);
#else
    return fract(sin(dot(pos.xyz, vec3(70.9898, 78.233, 32.4355))) * 43758.5453123);
#endif
}

float random(in vec4 pos) {
#ifdef RANDOM_SINLESS
    pos = fract(pos * RANDOM_SCALE);
    pos += dot(pos, pos.wzxy + 33.33);
    return fract((pos.x + pos.y) * (pos.z + pos.w));
#else
    float dot_product = dot(pos, vec4(12.9898,78.233,45.164,94.673));
    return fract(sin(dot_product) * 43758.5453);
#endif
}

vec2 random2(float p) {
    vec3 p3 = fract(vec3(p) * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yzx + 19.19);
    return fract((p3.xx + p3.yz) * p3.zy);
}

vec2 random2(vec2 p) {
    vec3 p3 = fract(p.xyx * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yzx + 19.19);
    return fract((p3.xx + p3.yz) * p3.zy);
}

vec2 random2(vec3 p3) {
    p3 = fract(p3 * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yzx + 19.19);
    return fract((p3.xx + p3.yz) * p3.zy);
}

vec3 random3(float p) {
    vec3 p3 = fract(vec3(p) * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yzx + 19.19);
    return fract((p3.xxy + p3.yzz) * p3.zyx); 
}

vec3 random3(vec2 p) {
    vec3 p3 = fract(vec3(p.xyx) * RANDOM_SCALE.xyz);
    p3 += dot(p3, p3.yxz + 19.19);
    return fract((p3.xxy + p3.yzz) * p3.zyx);
}

vec3 random3(vec3 p) {
    p = fract(p * RANDOM_SCALE.xyz);
    p += dot(p, p.yxz + 19.19);
    return fract((p.xxy + p.yzz) * p.zyx);
}

vec4 random4(float p) {
    vec4 p4 = fract(p * RANDOM_SCALE);
    p4 += dot(p4, p4.wzxy + 19.19);
    return fract((p4.xxyz + p4.yzzw) * p4.zywx);   
}

vec4 random4(vec2 p) {
    vec4 p4 = fract(p.xyxy * RANDOM_SCALE);
    p4 += dot(p4, p4.wzxy + 19.19);
    return fract((p4.xxyz + p4.yzzw) * p4.zywx);
}

vec4 random4(vec3 p) {
    vec4 p4 = fract(p.xyzx * RANDOM_SCALE);
    p4 += dot(p4, p4.wzxy + 19.19);
    return fract((p4.xxyz + p4.yzzw) * p4.zywx);
}

vec4 random4(vec4 p4) {
    p4 = fract(p4  * RANDOM_SCALE);
    p4 += dot(p4, p4.wzxy + 19.19);
    return fract((p4.xxyz + p4.yzzw) * p4.zywx);
}
#endif


#ifndef NOISEBLUR_SAMPLES
#define NOISEBLUR_SAMPLES 4.0
#endif

#ifndef NOISEBLUR_TYPE
#define NOISEBLUR_TYPE vec4
#endif

#ifndef NOISEBLUR_SAMPLER_FNC
#define NOISEBLUR_SAMPLER_FNC(TEX, UV) SAMPLER_FNC(TEX, UV)
#endif

#ifndef NOISEBLUR_RANDOM23_FNC
#define NOISEBLUR_RANDOM23_FNC(UV) random2(UV)
#endif

#ifndef FNC_NOISEBLUR
#define FNC_NOISEBLUR

NOISEBLUR_TYPE noiseBlur(in SAMPLER_TYPE tex, in vec2 st, in vec2 pixel, float radius) {
    float blurRadius = radius;
    vec2 noiseOffset = st;

    #ifdef NOISEBLUR_SECS
    noiseOffset += 1337.0*fract(NOISEBLUR_SECS * 0.1);
    #endif

    NOISEBLUR_TYPE result = NOISEBLUR_TYPE(0.0);
    for (float i = 0.0; i < NOISEBLUR_SAMPLES; ++i) {

        #if defined(BLUENOISE_TEXTURE) && defined(BLUENOISE_TEXTURE_RESOLUTION)
        vec2 noiseRand = sampleNearest(BLUENOISE_TEXTURE, noiseOffset.xy, BLUENOISE_TEXTURE_RESOLUTION).xy;
        #else 
        vec2 noiseRand = NOISEBLUR_RANDOM23_FNC(vec3(noiseOffset.xy, i));
        #endif

        noiseOffset = noiseRand;

        vec2 r = noiseRand;
        r.x *= TAU;
        
        #if defined(NOISEBLUR_GAUSSIAN_K)
        // box-muller transform to get gaussian distributed sample points in the circle
        vec2 cr = vec2(sin(r.x),cos(r.x))*sqrt(-NOISEBLUR_GAUSSIAN_K * log(r.y));
        #else
        // uniform sample the circle
        vec2 cr = vec2(sin(r.x),cos(r.x))*sqrt(r.y);
        #endif
        
        NOISEBLUR_TYPE color = NOISEBLUR_SAMPLER_FNC(tex, st + cr * blurRadius * pixel );
        // average the samples as we get em
        // https://blog.demofox.org/2016/08/23/incremental-averaging/
        result = mix(result, color, 1.0 / (i+1.0));
    }
    return result;
}

NOISEBLUR_TYPE noiseBlur(SAMPLER_TYPE tex, vec2 st, vec2 pixel) {
    NOISEBLUR_TYPE rta = NOISEBLUR_TYPE(0.0);
    float total = 0.0;
    float offset = random(vec3(12.9898 + st.x, 78.233 + st.y, 151.7182));
    for (float t = -NOISEBLUR_SAMPLES; t <= NOISEBLUR_SAMPLES; t++) {
        float percent = (t / NOISEBLUR_SAMPLES) + offset - 0.5;
        float weight = 1.0 - abs(percent);
        NOISEBLUR_TYPE color = NOISEBLUR_SAMPLER_FNC(tex, st + pixel * percent);
        rta += color * weight;
        total += weight;
    }
    return rta / total;
}

#endif
`;

export const gaussianBlur = /*glsl*/ `
    vec4 blur13(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
        vec4 color = vec4(0.0);
        vec2 off1 = vec2(1.411764705882353) * direction;
        vec2 off2 = vec2(3.2941176470588234) * direction;
        vec2 off3 = vec2(5.176470588235294) * direction;
        color += texture2D(image, uv) * 0.1964825501511404;
        color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;
        color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;
        color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;
        color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;
        color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;
        color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;
        return color;
    }

    vec4 blur5(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
        vec4 color = vec4(0.0);
        vec2 off1 = vec2(1.3333333333333333) * direction;
        color += texture2D(image, uv) * 0.29411764705882354;
        color += texture2D(image, uv + (off1 / resolution)) * 0.35294117647058826;
        color += texture2D(image, uv - (off1 / resolution)) * 0.35294117647058826;
        return color;
    }

    vec4 blur9(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
        vec4 color = vec4(0.0);
        vec2 off1 = vec2(1.3846153846) * direction;
        vec2 off2 = vec2(3.2307692308) * direction;
        color += texture2D(image, uv) * 0.2270270270;
        color += texture2D(image, uv + (off1 / resolution)) * 0.3162162162;
        color += texture2D(image, uv - (off1 / resolution)) * 0.3162162162;
        color += texture2D(image, uv + (off2 / resolution)) * 0.0702702703;
        color += texture2D(image, uv - (off2 / resolution)) * 0.0702702703;
        return color;
    }

    vec4 gaussianblur(sampler2D image, vec2 uv, float steps, vec2 resolution, vec2 direction) {

        vec4 blend = vec4(0.);
        float sum = 1.;
        float m = 1.;
        float n = steps;

        for (float i = 0.; i < 100.; i += 1.) {
            if(i >= 2. * steps) break;
            float k = i;
            float j = i - 0.5 * steps;
            blend += m * texture2D(image, uv + j * direction / resolution);
            m *= (n - k) / (k + 1.);
            sum += m;
        }

        return blend / sum;

    }
`;

export const parabola = /*glsl*/ `
    float parabola(float x, float k) {
        return pow(4.0*x*(1.0-x), k);
    }
`;

// Stuff from abeto?
export const falloff = /*glsl*/ `
    float _linstep(float begin, float end, float t) {
    return clamp((t-begin)/(end-begin), 0.0, 1.0);
}
float _pl(vec2 _input, vec2 start, vec2 end, float margin, float progress) {
    vec2 v = end-start;
    float dist = length(v);
    vec2 dir = v/dist;
    return dot(dir, _input-start-dir*(dist+margin)*progress);
}
float _pl(vec3 _input, vec3 start, vec3 end, float margin, float progress) {
    vec3 v = end-start;
    float dist = length(v);
    vec3 dir = v/dist;
    return dot(dir, _input-start-dir*(dist+margin)*progress);
}
float falloff(float _input, float start, float end, float margin, float progress) {
    float m = margin*sign(end-start);
    float p = mix(start-m, end, progress);
    return _linstep(p+m, p, _input);
}
float falloffsmooth(float _input, float start, float end, float margin, float progress) {
    float m = margin*sign(end-start);
    float p = mix(start-m, end, progress);
    return smoothstep(p+m, p, _input);
}
float falloff(vec2 _input, vec2 start, vec2 end, float margin, float progress) {
    return _linstep(0.0, -margin, _pl(_input, start, end, margin, progress));
}
float falloffsmooth(vec2 _input, vec2 start, vec2 end, float margin, float progress) {
    return smoothstep(0.0, -margin, _pl(_input, start, end, margin, progress));
}
float falloff(vec3 _input, vec3 start, vec3 end, float margin, float progress) {
    return _linstep(0.0, -margin, _pl(_input, start, end, margin, progress));
}
float falloffsmooth(vec3 _input, vec3 start, vec3 end, float margin, float progress) {
    return smoothstep(0.0, -margin, _pl(_input, start, end, margin, progress));
}

float pcurve(float x, float a, float b) {
    float k = pow(a+b, a+b)/(pow(a, a)*pow(b, b));
    return k*pow(x, a)*pow(1.0-x, b);
}
float efit(float x, float a1, float a2, float b1, float b2) {
    return b1+((x-a1)*(b2-b1))/(a2-a1);
}
float fit(float x, float a1, float a2, float b1, float b2) {
    return clamp(efit(x, a1, a2, b1, b2), min(b1, b2), max(b1, b2));
}
float fit01(float x, float a1, float a2) {
    return fit(x, 0.0, 1.0, a1, a2);
}
float fit10(float x, float a1, float a2) {
    return fit(x, 1.0, 0.0, a1, a2);
}
float fit11(float x, float a1, float a2) {
    return fit(x, -1.0, 1.0, a1, a2);
}
vec3 efit(vec3 x, vec3 a1, vec3 a2, vec3 b1, vec3 b2) {
    return b1+((x-a1)*(b2-b1))/(a2-a1);
}
vec3 fit(vec3 x, vec3 a1, vec3 a2, vec3 b1, vec3 b2) {
    return clamp(efit(x, a1, a2, b1, b2), min(b1, b2), max(b1, b2));
}
vec3 fit01(vec3 x, vec3 a1, vec3 a2) {
    return fit(x, vec3(0.0), vec3(1.0), a1, a2);
}
vec3 fit10(vec3 x, vec3 a1, vec3 a2) {
    return fit(x, vec3(1.0), vec3(0.0), a1, a2);
}
vec3 fit11(vec3 x, vec3 a1, vec3 a2) {
    return fit(x, vec3(-1.0), vec3(1.0), a1, a2);
}
`;
